module.exports = __webpack_public_path__ + "img/mascotas.2da715d0.webp";